"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _NavMarker = _interopRequireDefault(require("react-rhumb/NavMarker"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Raven = _interopRequireDefault(require("Raven"));

var CustomPropTypes = _interopRequireWildcard(require("../../../constants/PropTypes"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _FormattedDuration = _interopRequireDefault(require("I18n/components/FormattedDuration"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var RequestState = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/RequestState"));

var _Review = _interopRequireDefault(require("ecosystem-marketplace-core/records/Review"));

var _auth = require("../../../selectors/auth");

var _ReviewsActions = require("../../../actions/ReviewsActions");

var _NotificationActions = require("ReduxMessenger/actions/NotificationActions");

var _AppReviewability = _interopRequireDefault(require("../../../records/AppReviewability"));

var _Reviewability = require("../../../constants/Reviewability");

var _requestStates = require("../../../selectors/requestStates");

var AsyncReviewWizard = (0, _Loadable.default)({
  loader: function loader() {
    return import(
    /* webpackChunkName: 'review-wizard' */
    'ecosystem-marketplace-core/components/reviews/wizard/ReviewWizard');
  }
});
var textPath = 'appMarketplace.detail.reviews.unreviewable';

var ReviewWizard = function ReviewWizard(_ref) {
  var appName = _ref.appName,
      appIcon = _ref.appIcon,
      displayName = _ref.displayName,
      offeringId = _ref.offeringId,
      onClose = _ref.onClose,
      onSuccess = _ref.onSuccess,
      onTrackInteraction = _ref.onTrackInteraction,
      overallRating = _ref.overallRating,
      postUnreviewableAlert = _ref.postUnreviewableAlert,
      reviewability = _ref.reviewability,
      reviewWriteStatus = _ref.reviewWriteStatus,
      submitReview = _ref.submitReview,
      userEmail = _ref.userEmail;
  var defaultReview = (0, _react.useMemo)(function () {
    return overallRating ? new _Review.default().setOverallRating(overallRating) : undefined;
  }, [overallRating]);
  var handleSubmit = (0, _react.useCallback)(function (review) {
    submitReview(review.merge({
      offeringId: offeringId
    })).then(function () {
      onSuccess();
    }).catch(function (err) {
      _Raven.default.captureMessage('Failed to leave a review', {
        level: 'error',
        extra: (0, _extends2.default)({
          offeringId: offeringId
        }, err)
      });
    });
    onTrackInteraction('submit review', 'review');
  }, [offeringId, onSuccess, onTrackInteraction, submitReview]);
  var onWizardLoad = (0, _react.useCallback)(function () {
    onTrackInteraction('open review wizard', 'review');
  }, [onTrackInteraction]);
  var onStepChange = (0, _react.useCallback)(function (prevStep, nextStep) {
    onTrackInteraction('change review wizard step', 'review', nextStep, {
      prevStep: prevStep
    });
  }, [onTrackInteraction]);
  var onReject = (0, _react.useCallback)(function () {
    onTrackInteraction('dismiss review wizard', 'review');
    onClose();
  }, [onTrackInteraction, onClose]);
  (0, _react.useEffect)(function () {
    if (!reviewability.isReviewable()) {
      var reason = reviewability.getUnreviewableReason();

      var message = _react.default.createElement(_FormattedMessage.default, {
        message: textPath + "." + reason
      });

      if (reason === _Reviewability.UnreviewableReasons.UNINSTALLED) {
        var uninstallWindow = _react.default.createElement(_FormattedDuration.default, {
          from: 1,
          to: reviewability.get('maxMillisAfterUninstall')
        });

        message = _react.default.createElement(_FormattedReactMessage.default, {
          message: textPath + "." + reason,
          options: {
            uninstallWindow: uninstallWindow
          }
        });
      }

      postUnreviewableAlert({
        id: _Reviewability.UNREVIEWABLE_ALERT_ID,
        type: 'danger',
        titleText: _react.default.createElement(_FormattedMessage.default, {
          message: textPath + ".titleText"
        }),
        message: message
      });
    }
  }, [reviewability, postUnreviewableAlert]);
  return _react.default.createElement(_NavMarker.default, {
    name: "REVIEW_WIZARD_LOAD"
  }, reviewability.isReviewable() && _react.default.createElement(AsyncReviewWizard, {
    appName: appName,
    appIcon: appIcon,
    failed: reviewWriteStatus === RequestState.FAILED,
    defaultReview: defaultReview,
    displayName: displayName,
    loading: reviewWriteStatus === RequestState.PENDING,
    onReject: onReject,
    onConfirm: handleSubmit,
    onStepChange: onStepChange,
    onWizardLoad: onWizardLoad,
    userEmail: userEmail
  }));
};

ReviewWizard.propTypes = {
  appName: _propTypes.default.string.isRequired,
  appIcon: _propTypes.default.string.isRequired,
  displayName: _propTypes.default.string,
  offeringId: _propTypes.default.number.isRequired,
  onClose: _propTypes.default.func.isRequired,
  onSuccess: _propTypes.default.func,
  onTrackInteraction: _propTypes.default.func.isRequired,
  overallRating: _propTypes.default.number,
  postUnreviewableAlert: _propTypes.default.func.isRequired,
  reviewability: _propTypes.default.instanceOf(_AppReviewability.default).isRequired,
  reviewWriteStatus: CustomPropTypes.requestState.isRequired,
  submitReview: _propTypes.default.func.isRequired,
  userEmail: _propTypes.default.string
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    displayName: (0, _auth.getUserDisplayName)(state),
    reviewWriteStatus: (0, _requestStates.getReviewWriteRequestState)(state),
    userEmail: (0, _auth.getUserEmail)(state)
  };
};

var mapDispatchToProps = {
  submitReview: _ReviewsActions.submitReview,
  postUnreviewableAlert: _NotificationActions.postNotification
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReviewWizard);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/reviews/ReviewWizard.js
// module id = 433
// module chunks = 209 210 211 212